import type { OtpCheckoutBaseline } from "utils/otpPaymentVerification";

const OTP_CHECKOUT_CONTEXT_KEY = "rivetai_otp_checkout_context";

export type OtpCheckoutContext = {
  workspaceId?: string;
  projectId?: string;
  baseline?: OtpCheckoutBaseline;
};

export const persistOtpCheckoutContext = (context: OtpCheckoutContext): void => {
  if (typeof window === "undefined") {
    return;
  }
  try {
    sessionStorage.setItem(OTP_CHECKOUT_CONTEXT_KEY, JSON.stringify(context));
  } catch {
    // ignore quota / private mode errors
  }
};

export const readOtpCheckoutContext = (): OtpCheckoutContext | null => {
  if (typeof window === "undefined") {
    return null;
  }
  try {
    const raw = sessionStorage.getItem(OTP_CHECKOUT_CONTEXT_KEY);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw) as OtpCheckoutContext;
    if (!parsed || typeof parsed !== "object") {
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
};

export const clearOtpCheckoutContext = (): void => {
  if (typeof window === "undefined") {
    return;
  }
  try {
    sessionStorage.removeItem(OTP_CHECKOUT_CONTEXT_KEY);
  } catch {
    // ignore
  }
};
